import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { PhoneRevalidationTemplate } from '../../templates/PhoneRevalidationTemplate'

import {
  isValid as isValidPhone,
  removeMask as removePhoneMask,
  isLandline,
} from '../../../util/PhonePattern'
import { sendPinCode } from '../../../api/pinCodeApi'
import { handlePhoneValidationExceptions } from '../../../util/phoneExceptions'
import { formatedTime } from '../../../util/date'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'
import { CountdownContext } from '../../../util/providers/CountdownProvider'
import { revalidationCheckAttempts } from '../../../api/attemptCheckAPI'

export const SendPhoneRevalidationPinCodePage = ({ onBack, onSuccess }) => {
  const { oldPhone, phone, token, updateValidations, lurker } = useContext(RevalidationContext)
  const { lockTime, checkAttemptLockTime } = useContext(CountdownContext)
  const isLocked = lockTime > 0

  const { control, handleSubmit, formState, clearErrors, reset } = useForm({
    reValidateMode: 'onBlur',
    mode: 'onBlur',
    defaultValues: { phone: phone?.value ?? '' },
  })

  const [alreadyHasPhone, setAlreadyHasPhone] = useState(!!phone?.value)
  const [error, setError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const shouldDisableSendButton = !formState.isValid || isSubmitting

  const checkAttemptLockTimeCallback = () => revalidationCheckAttempts(token)

  useEffect(() => {
    oldPhone && reset({ phone: oldPhone })
  }, [])

  const handleBack = () => {
    if (alreadyHasPhone || (!phone?.value && !alreadyHasPhone)) {
      onBack && onBack()
    }

    setAlreadyHasPhone(!!phone?.value)
    setError(null)
    reset({ phone: phone?.value })
  }

  const handleClickFooterButton = () => {
    setAlreadyHasPhone(false)
    setError(null)
    reset({ phone: '' })
  }

  const onValidatePhoneSuccess = (phoneValue, opts = {}) => {
    lurker.viewMessageEvt('success', opts)

    setIsSubmitting(false)
    if (onSuccess) {
      updateValidations('phone', phoneValue)
      onSuccess()
    }
  }

  const onValidatePhoneError = (error = {}, opts = {}) => {
    setIsSubmitting(false)

    const { lurkerExtraData, errorInfo } = handlePhoneValidationExceptions(error, opts)

    lurker.errorMessageEvt('error', { ...lurkerExtraData, ...opts })
    setError({
      ...errorInfo,
      message: errorInfo.message?.replace(/{LOCK_TIME}/, formatedTime(lockTime)),
    })
  }

  const onSubmit = data => {
    const phoneValue = removePhoneMask(data.phone)
    const landLine = isLandline(phoneValue)
    const trackingOpts = { landLine, phoneValue }
    const newPhone = isValidPhone(phoneValue) ? phoneValue : null

    lurker.clickEvt('submit', trackingOpts)
    setIsSubmitting(true)

    sendPinCode(newPhone, 'PHONE', token)
      .then(() => {
        onValidatePhoneSuccess(phoneValue, trackingOpts)
      })
      .catch(error => onValidatePhoneError(error, trackingOpts))
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  useEffect(() => {
    lurker.pageLoadEvt('revalidate_phone_send')
    checkAttemptLockTime(checkAttemptLockTimeCallback)
  }, [])

  return (
    <PhoneRevalidationTemplate
      shouldDisableSendButton={shouldDisableSendButton}
      isSubmitting={isSubmitting}
      onBack={handleBack}
      onClickFooterButton={handleClickFooterButton}
      onSubmit={handleSubmit(onSubmit)}
      clearErrors={() => clearErrors('phone')}
      alreadyHasPhone={alreadyHasPhone}
      error={error}
      inputControl={control}
      isLocked={isLocked}
      lockTime={lockTime}
    />
  )
}

SendPhoneRevalidationPinCodePage.propTypes = {
  onBack: PropTypes.func,
  onSuccess: PropTypes.func,
}
